export const Wifi = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.999 19.25C11.792 19.25 11.624 19.418 11.626 19.625C11.625 19.832 11.793 20 12 20C12.207 20 12.375 19.832 12.375 19.625C12.375 19.418 12.207 19.25 11.999 19.25"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.591 12.0001C8.683 8.24705 15.316 8.24705 19.408 12.0001"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1.594 7.804C7.341 2.732 16.659 2.732 22.406 7.804"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.579 15.821C10.02 13.393 13.979 13.393 16.42 15.821"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Wifi</div>
    </div>
  );
};

export const WorkJob = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.25 10V8C14.25 7.44772 13.8023 7 13.25 7H10.75C10.1977 7 9.75 7.44772 9.75 8V10"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="7"
          y="10"
          width="10"
          height="7"
          rx="1.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="3"
          y="3"
          width="18"
          height="18"
          rx="5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Work job</div>
    </div>
  );
};

export const LaptopTable = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M18 10L6.00005 10V4.11111C6.00005 3.49747 6.49749 3.00001 7.11114 3L16.8889 3C17.1836 2.99999 17.4662 3.11706 17.6746 3.32543C17.883 3.5338 18 3.81642 18 4.11111V10Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.5 10H18.5C18.7761 10 19 10.2239 19 10.5V11C19 12.1046 18.1046 13 17 13H7C5.89543 13 5 12.1046 5 11V10.5C5 10.2239 5.22386 10 5.5 10Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2 21V13.5C2 13.2239 2.22386 13 2.5 13H21.5C21.7761 13 22 13.2239 22 13.5V21H14V13"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22 17H14"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Laptop table</div>
    </div>
  );
};
